<svelte:options tag={null} />

<script lang="ts">
  import type { AccordionSize } from './accordion.types';
  import { EventHandler } from '../../utilities/EventHandler';

  export let label: string;
  export let size: AccordionSize = 'm';
  export let iconname: string | undefined = undefined;
  export let iconcolor: string | undefined = undefined;
  export let open = false;
  export let disabled = false;
  export let nopadding = false;
  export let checkable = false;
  let eventHandler = new EventHandler();
  $: isOpen = open ? true : false;
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function generateIconName(
    iconname: string,
    iconcolor: string,
    iconsize: string,
  ): string {
    return iconsize === 's'
      ? `${iconname} size="1.5rem"`
      : `${iconname} size="2rem" fill="${iconcolor}"`;
  }

  function handleState(): void {
    eventHandler.dispatch('on-heading-click', isOpen);
    isOpen = !isOpen;
  }
</script>

<div
  class="mc-accordion {size ? `mc-accordion--${size}` : ''}
    {isOpen ? ' is-open' : ''}
    {nopadding ? ' mc-accordion--no-padding' : ''}
    {checkable ? ' mc-accordion--checkable' : ''}
    {disabled ? ' is-disabled' : ''} 
  {userClass}"
  {...attributes}
>
  <div class="mc-accordion__header">
    <slot name="beforeLabel" />
    <h2 class="mc-accordion__title">
      <button
        id="m-accordion"
        class="mc-accordion__trigger"
        type="button"
        aria-controls="content"
        aria-expanded={!isOpen}
        {disabled}
        on:click={handleState}
      >
        {#if iconname}
          <span class="mc-accordion__icon">
            {@html `<${generateIconName(iconname, String(iconcolor), size)} />`}
          </span>
        {/if}
        {label}
        <slot name="afterLabel" />
      </button>
    </h2>
  </div>
  <div
    id="content"
    class="mc-accordion__content"
    aria-hidden={isOpen}
    aria-labelledby="m-accordion"
  >
    <slot />
  </div>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.accordion';

  :host {
    display: block;
  }
</style>
